import { Reducer } from 'redux';
import { produce } from 'immer';

import { ROLES_TYPES, RoleState } from './types';

export const INITIAL_STATE: RoleState = {
  rolesList: [],
};

const reducer: Reducer<RoleState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case ROLES_TYPES.SET_DATA_ROLELIST:
        draft.rolesList = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
